import { Account } from 'src/api/@generated/backend';

import { api } from 'src/api';
import { createAppAsyncThunk } from 'src/state/thunk-api';
import { handleError } from 'src/utils/error-utils';

export const fetchAccountsActionCreator = createAppAsyncThunk<Account[]>('request/fetchAccounts', async () => {
  try {
    return await api.accountController.getCustomerAccount();
  } catch (error) {
    handleError(error);
    return Promise.reject();
  }
});
